import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../common/dropdown'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { Tooltip } from '../../../common/tooltip'
import { valToPercent } from '../../../helpers/value'
import { HandleDetail } from '../../common/handleDetail'
import { TextEllipsisStaticLine } from './../../../common/textEllipsis/TextEllipsisStaticLine'
import classes from './index.module.scss'
import { selectBusinessSizeById } from './store/slice'

export const TableItem = ({
  title,
  subTitle,
  indicatorName,
  ids,
  getDataFromRedux,
  formatNameCell,
  detailParamKey,
  segmentation,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const COLUMN_ID = {
    STT: 'STT',
    NAME: 'name',
    COL_NUMBER_OF_COMPANIES: 'numberCompanies',
    COL_PERCENT_OF_TOTAL_COMPANIES: 'percentCompanies',
  }

  const schema = Object.keys(COLUMN_ID).map((key, index) => {
    const colId = COLUMN_ID[key]
    const title =
      'portfolio.summary.' + (colId === COLUMN_ID.NAME ? indicatorName : key)

    return {
      colId,
      title,
      isI18n: true,
      isHtml: true,
      parentThStyle: { verticalAlign: 'baseline' },
      thStyle: {
        justifyContent: index > 1 ? 'end' : 'start',
        textAlign: index > 1 ? 'right' : 'left',
      },
      tdStyle: {
        width: colId === COLUMN_ID.NAME ? '100%' : '',
        textAlign: index > 1 ? 'right' : 'left',
      },
      render: (data, { rowId, rowIndex }) => {
        switch (colId) {
          case COLUMN_ID.STT:
            return rowIndex + 1
          case COLUMN_ID.NAME:
            if (segmentation === 'BusinessSize') {
              return <CellTooltip data={data} rowId={rowId} />
            } else {
              return (
                <TextEllipsisStaticLine
                  text={formatNameCell ? formatNameCell(data) : data}
                  isI18n={false}
                  lineClamp={1}
                />
              )
            }

          case COLUMN_ID.COL_NUMBER_OF_COMPANIES:
            return (
              <HandleDetail
                path="PortfolioInsights/Details"
                otherParams={{
                  param: {
                    [detailParamKey]: rowId,
                    Rank: ['BusinessSize', 'YearOfOperation'].includes(
                      segmentation,
                    )
                      ? !rowId
                        ? 0
                        : rowIndex + 1
                      : rowIndex + 1,
                    Segmentation: segmentation,
                  },
                }}
              >
                {data}
              </HandleDetail>
            )
          case COLUMN_ID.COL_PERCENT_OF_TOTAL_COMPANIES:
            return valToPercent(data, locale, false)
          default:
            return data
        }
      },
    }
  })

  return (
    <div>
      <div className={classes.title}>
        <Element
          elementName="span"
          className="fw600"
          style={{ fontSize: 14, color: '#191D25' }}
        >
          <Translate value={title} />
        </Element>
        &nbsp;
        {subTitle && (
          <Element elementName="span" style={{ color: '#3A414B' }}>
            <Translate value={subTitle} />
          </Element>
        )}
      </div>

      <div>
        <Table
          ids={ids}
          getDataFromRedux={getDataFromRedux}
          schema={schema}
          autoHeightMax={3000}
          isCenterNoData={false}
          noDataPaddingTop={50}
        />
      </div>
    </div>
  )
}

const CellTooltip = ({ data, rowId }) => {
  const dataCell = useSelector(selectBusinessSizeById(rowId, 'description'))
  if (dataCell) {
    return (
      <Tooltip
        tooltipContent={dataCell}
        position={positionDropdown.TOP_START_RIGHT}
      >
        <Element>{data}</Element>
      </Tooltip>
    )
  }
  return <Element>{data}</Element>
}
